module.exports = "<div class=\"ctx-progressbar-content\">\n    <div class=\"progress\">\n        <div class=\"progress-bar\" role=\"progressbar\" data-transitiongoal=\"ctxProgressbarCtrl.now\"></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxProgressbar/ctxProgressbar.template.html
// module id = 256
// module chunks = 0 1